<template>
    <div class="dialog-advanced-filter" v-if="show">
        <div class="dialog-advanced-filter__header">
            <span class="dialog-advanced-filter__title">
                {{ translate('btn_advanced_filters') }}
            </span>
            <div class="dialog-advanced-filter__action">
                <el-link v-if="hasFilters" @click="clearFilters">
                    {{ translate('clear_filters') }}
                </el-link>
                <el-link @click="$emit('applyFilter')">
                    {{ translate('apply_filters') }}
                </el-link>
            </div>
        </div>
        <div class="dialog-advanced-filter__content">
            <el-form>
                <el-collapse v-model="collapseSelected">
                    <el-collapse-item
                        :title="translate('operation_date')"
                        name="1"
                    >
                        <el-date-picker
                            v-model='filter.initialDate'
                            class='mr-2'
                            type='date'
                            :placeholder="translate('rangeInicialDate')"
                            format='dd/MM/yyyy'
                            @change='handleDateChange'
                        /><el-date-picker
                            v-model='filter.endDate'
                            class='mr-2'
                            type='date'
                            :placeholder="translate('rangeFinalDate')"
                            format='dd/MM/yyyy'
                            @change='handleDateChange'
                        />
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('operation_type')"
                        name="2"
                    >
                        <el-checkbox-group
                            v-model='filter.transactionType'
                            class=""
                            @change='handleDateChange'
                            :max="1"
                        >
                            <el-checkbox :label="transactions.NOTA_FISCAL" class="checkbox-area_view-invoice-filter">
                                {{ translate('invoice') }}
                            </el-checkbox>
                            <el-checkbox :label="transactions.TRANSFERENCIA_INTERNA" class="checkbox-area_view-invoice-filter">
                                {{ translate('internal_transfer') }}
                            </el-checkbox>
                            <el-checkbox :label="transactions.TRANSFERENCIA_TITULARIDADE" class="checkbox-area_view-invoice-filter">
                                {{ translate('ownership_transfer') }}
                            </el-checkbox>
                            <el-checkbox :label="transactions.EXPORTACAO" class="checkbox-area_view-invoice-filter">
                                {{ translate('export') }}
                            </el-checkbox>
                            <el-checkbox :label="transactions.ESTORNO" class="checkbox-area_view-invoice-filter">
                                {{ translate('reversal') }}
                            </el-checkbox>
                            <el-checkbox :label="transactions.EMPRESTIMO" class="checkbox-area_view-invoice-filter">
                                {{ translate('emprestimo_operation') }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('origin_destination')"
                        name="3"
                    >
                        <div class="selectcontainer_origin_destination">
                            <el-select
                                v-model='filter.origin'
                                :placeholder="translate('select_origin_warehouse')"
                                filterable
                                clearable
                                remote
                                :remote-method='this.fetchOrigin'
                                :loading='searchingOrigin'
                                :no-data-text="(!searchingOrigin && searchingOriginText && searchingOriginText.length < 3) ? $t('warehouse.add_modal.type_more_than_three_chars') : $t('warehouse.add_modal.no_data_text')"
                            >
                                <el-option
                                    v-for="originWarehouse in originWarehouses"
                                    :key="originWarehouse.id"
                                    :label="originWarehouse.unidade"
                                    :value="originWarehouse.id"
                                >
                                    {{ originWarehouse.unidade }}
                                </el-option>
                            </el-select>
                            <el-select
                                v-model='filter.destination'
                                :placeholder="translate('select_destination_warehouse')"
                                filterable
                                clearable
                                remote
                                :remote-method='fetchDestination'
                                :loading='searchingDestination'
                                :no-data-text="(!searchingDestination && searchingDestinationText && searchingDestinationText.length < 3) ? $t('warehouse.add_modal.type_more_than_three_chars') : $t('warehouse.add_modal.no_data_text')"
                            >
                                <el-option
                                    v-for="destinationWarehouse in destinationWarehouses"
                                    :key="destinationWarehouse.id"
                                    :label="destinationWarehouse.unidade"
                                    :value="destinationWarehouse.id"
                                >
                                    {{ destinationWarehouse.unidade }}
                                </el-option>
                            </el-select>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>
    </div>
</template>

<script>
import ArmazemModuleService from '@/services/ArmazemModuleService';
import { Transactions } from '@/modules/warehouse/constants/TransactionsEnum';

export default {
    name: 'dialog-advanced-filters',
    data() {
        return {
            transactions: Transactions,
            collapseSelected: [1],
            filter: {
                initialDate: null,
                endDate: null,
                transactionType: [],
                origin: null,
                destination: null
            },
            searchingOrigin: false,
            searchingOriginText: null,
            searchingDestination: false,
            searchingDestinationText: null,
            originWarehouses: [],
            destinationWarehouses: []
        };
    },
    props: {
        show: {
            type: Boolean,
            required: true,
            default: () => false
        }
    },
    mounted() {
        this.$emit('handleFilter', this.filter, true);
    },
    computed: {
        hasFilters() {
            return (
                true
            );
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.messages.view_warehouse_filter';
            return this.$t(`${base}.${key}`, params);
        },
        handleDateChange() {
            this.$emit('handleFilter', this.filter, false);
        },
        clearFilters() {
            this.filter.initialDate = null;
            this.filter.endDate = null;
            this.filter.transactionType = [];
            this.filter.origin = null;
            this.filter.destination = null;
            this.$emit('clear');
        },
        async fetchOrigin(query) {
            this.searchingOriginText = query;
            if (query && query.length >= 3) {
                this.searchingOrigin = true;
                await ArmazemModuleService.getWarehousesByName(query)
                .then(({ data }) => {
                    this.originWarehouses = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.translate('error_fetching_origin_warwhouse')
                    });
                });
                this.searchingOrigin = false;
            } else {
                this.originWarehouses = [];
            }
        },
        async fetchDestination(query) {
            this.searchingDestinationText = query;
            if (query && query.length >= 3) {
                this.searchingDestination = true;
                await ArmazemModuleService.getWarehousesByName(query)
                .then(({ data }) => {
                    this.destinationWarehouses = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.translate('error_fetching_destination_warwhouse')
                    });
                });
                this.searchingDestination = false;
            } else {
                this.destinationWarehouses = [];
            }
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-advanced-filter {
    width: 100%;

    .dialog-advanced-filter__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dialog-advanced-filter__title {
            font-weight: 500;
            font-size: 16px;
            color: #00413c;
        }

        .dialog-advanced-filter__action {
            display: flex;
            gap: 16px;

            .el-link:first-child {
                color: #e35e58;
                font-size: 14px;
                font-weight: 400;
            }

            .el-link:last-child {
                color: #036be4;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .dialog-advanced-filter__content {
        .dialog-advanced-filter__content__status {
            display: grid;
            grid-template-columns: 1fr 1fr auto;
            gap: 16px;
        }

        .dialog-advanced-filter__content__cultivation {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 32px;
        }
    }
}

.checkbox-area_view-invoice-filter {
    padding: 0 12px 0 0;
}

.selectcontainer_origin_destination {
    display: flex;
    gap: 16px;
}
</style>
